import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Loader } from "rsuite";
import AreaChart from "../../../Components/Charts/AreaChart";
import { axInst } from "../../../Components/Login/Service";

const fetchServiceExperience = async (body) => {
  try {
    const res = await axInst.post(
      "collbax-service/collbax_service_zone_quality",
      body,
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export default function ServiceExperience() {
  const { data, submitted } = useSelector((e) => e.filtersServiceCollabax);

  const payload = {
    ...data,
    Dealer_status: "SCV_Customer_Experience",
  };

  const {
    data: apiData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["serviceExperience", payload],
    queryFn: () => fetchServiceExperience(payload),
    cacheTime: 0,
    staleTime: 0,
  });

  if (isFetching)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  if (isError) return <div>Error loading data</div>;

  // 🔥 Transform API response correctly
  const chartsData = apiData
    ? Object.entries(apiData).map(([title, value]) => {
        // Find dynamic FY keys
        const fyKeys = Object.keys(value)
          .filter((key) => key.startsWith("FY"))
          .sort();

        const prevFY =
          fyKeys.length > 1
            ? fyKeys[0]
            : fyKeys.length === 1
              ? fyKeys[0]
              : null;
        const currFY = fyKeys.length > 1 ? fyKeys[1] : null;

        return {
          title,
          monthlyData: value.Month_wise_revenue || {},
          target: value.Target,
          previousYear: {
            label: prevFY,
            value: prevFY ? value[prevFY] : null,
          },
          ytdActual: currFY
            ? { label: currFY, value: value[currFY] }
            : value.YTD_Actual,
        };
      })
    : [];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
      {chartsData.map((chart, index) => {
        let endpoint = "collbax-service/collbax_sso_service_revenue";
        let modalPayload = {};

        const titleLower = chart?.title?.toLowerCase() || "";
        if (titleLower.includes("post") && titleLower.includes("feedback")) {
          endpoint = "collbax-service/collbax_service_sso_quality";
          modalPayload = { sso_status: "PSF" };
        } else if (titleLower.includes("nps")) {
          endpoint = "collbax-service/collbax_service_sso_quality";
          modalPayload = { sso_status: "NPS" };
        } else if (
          titleLower.includes("customer") &&
          titleLower.includes("score")
        ) {
          endpoint = "collbax-service/collbax_service_sso_quality";
          modalPayload = { sso_status: "CES" };
        } else if (titleLower.includes("ces")) {
          endpoint = "collbax-service/collbax_service_sso_quality";
          modalPayload = { sso_status: "CES" };
        } else if (titleLower.includes("cptc")) {
          endpoint = "collbax-service/collbax_service_sso_quality";
          modalPayload = { sso_status: "CPTC" };
        } else if (titleLower.includes("iptv") && titleLower.includes("c1")) {
          endpoint = "collbax-service/collbax_service_sso_quality";
          modalPayload = { sso_status: "IPTV_C1" };
        } else if (
          titleLower.includes("iptv") &&
          titleLower.includes("total")
        ) {
          endpoint = "collbax-service/collbax_service_sso_quality";
          modalPayload = { sso_status: "IPTV" };
        } else if (titleLower.includes("gold") && titleLower.includes("tech")) {
          endpoint = "collbax-service/collbax_service_sso_quality";
          modalPayload = { sso_status: "GOLD_TECH" };
        }

        return (
          <AreaChart
            key={index}
            title={chart.title}
            data={chart.monthlyData}
            target={chart.target}
            previousYear={chart.previousYear}
            ytdActual={chart.ytdActual}
            modalEndpoint={endpoint}
            modalPayload={modalPayload}
          />
        );
      })}
    </div>
  );
}
